import React, { useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import logoMark from "../../../images/fly-miles-mark.png";
import logoFull from "../../../images/fly-miles-logo.svg";

export function  NavMenuToggle(){
	setTimeout(()=>{	
		let mainwrapper = document.querySelector("#main-wrapper");
		if(mainwrapper.classList.contains('menu-toggle')){
			mainwrapper.classList.remove("menu-toggle");
		}else{
			mainwrapper.classList.add("menu-toggle");
		}
	},200);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        <img className="logo-abbr" src={logoMark} alt="Fly Miles" style={{ width: "2.5rem", height: "2.5rem", objectFit: "cover" }} />
        <img className="brand-title" src={logoFull} alt="Fly Miles" style={{ height: "3.5rem", width: "auto" }} />
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
